<figure class="canvas" #drawFigure (window:resize)="onResize($event)">
    <!-- #stats-output is used in assets/scripts/stats.min.js and use_stats.js to show fps stats -->
    <!-- <div id="stats-output"></div> -->
</figure>